import styles from "./home-cta-button.module.scss";
export interface Input extends Marko.HTML.A {}

a ...input class=[input.class, styles.cta]
